// import {
//   PSReqDTO,
//   PSFReqDTO,
//   PSFResDTO,
//   IOrganizacniStrukturatJednotky,
//   IOrganizacniStrukturatZamestnanci,
// } from "types/types";

import useRequest from "./useRequest";

// ORGANIZACNI STRUKTURA
export function useOrganizacniStrukturaJednotkyAPI() {
  return useRequest({
    url: "/o/organizacnistruktura-rest/organizacni-struktura/jednotky/",
  });
}

export function useOrganizacniStrukturaOddeleniAPI(id) {
  return useRequest({
    url: "/o/organizacnistruktura-rest/organizacni-struktura/oddeleni/" + ("?jednotkaId=" + (id ?? "")),
  });
}

// export function useOrganizacniStrukturatZamestnanciAPI(id: string, data: PSReqDTO) {
export function useOrganizacniStrukturaZamestnanciAPI(id, data, specialSort) {
  // return useRequest<PSFResDTO<IOrganizacniStrukturatZamestnanci>>({
  return useRequest({
    url: "/o/organizacnistruktura-rest/organizacni-struktura/zamestnanci/" + id + "?specialSort=" + specialSort,
    method: "POST",
    data,
  });
}
